import { render } from "./App.vue?vue&type=template&id=5d60a56c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5d60a56c&lang=scss"

import exportComponent from "/Users/jquesada/repos/sundevil/sundevil-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__